import { createContext } from 'react';
export const FileDropScopeContext = createContext(undefined);
const targets = [];
export const handledFileDropEvents = new WeakSet();
export function registerFileDropTarget(target) {
    targets.at(-1)?.resetState?.();
    targets.push(target);
    return () => {
        const index = targets.indexOf(target);
        if (index !== -1)
            targets.splice(index, 1);
    };
}
export function getFileDropTarget(target, files = true) {
    const fallback = files ? targets.at(-1) : targets.findLast((entry) => !entry.filesOnly);
    if (!files || !fallback?.scope || !(target instanceof Node))
        return fallback?.id;
    const boundary = targets.findLastIndex((entry) => entry.scope === undefined);
    return (targets.slice(boundary + 1).findLast((entry) => entry.scope?.current?.contains(target))?.id ??
        fallback.id);
}
//# sourceMappingURL=fileDropTargets.js.map